/** Stable lookup keys plus bounded HTTP templates; never derive names from request URLs. */
export const PILOT_ENDPOINTS = Object.freeze([
  Object.freeze({
    slice: "efficientReduxAPI",
    endpoint: "getCreatorConfig",
    name: "getcreatorconfig",
    method: "GET",
    path: "/api/c/getCreatorConfigAndAuthorizations",
  }),
  Object.freeze({
    slice: "reduxAPI",
    endpoint: "getCreatorData",
    name: "getcreatordata",
    method: "GET",
    path: "/api/c/fetchCreatorDetailsShop",
  }),
]);
export const RELEASE_2_ENDPOINTS = Object.freeze([
  ...PILOT_ENDPOINTS.map((endpoint) =>
    Object.freeze({ ...endpoint, owner: "home" })
  ),
  Object.freeze({
    slice: "reduxAPI",
    endpoint: "postSingleProductLink",
    name: "postsingleproductlink",
    method: "POST",
    path: "/api/c/convertSingleProductLink",
    owner: "diy_single_product",
  }),
  Object.freeze({
    slice: "reduxAPI",
    endpoint: "getScrapingFailureDomains",
    name: "getscrapingfailuredomains",
    method: "GET",
    path: "/api/c/getScrapingFailureDomains",
    owner: "diy_single_product",
  }),
]);
export const apiRegistry = Object.freeze({
  lookup: (slice: string, endpoint: string) =>
    RELEASE_2_ENDPOINTS.find(
      (entry) => entry.slice === slice && entry.endpoint === endpoint
    )?.name,
});
export const API_NAMES = Object.freeze(
  RELEASE_2_ENDPOINTS.map((entry) => entry.name)
);
